export enum SplitIOAPIKey {
  Dev = 'p4puv6vftj7vm8vs4q47j6khsp6rc7lme5j7',
  QA = 'db82nkmd7u4fpv99rqg3gcaqc3gpp9ejjtma',
  UAT = '4aas2007oqj6a5n6ti0ivtt0jo93vkm5runn',
  Prod = '11psihloj4bb4es5fo7v05bv8h0b29fjkd1',
}

export const getSplitIOAPIKey = (): string => {
  const hostname = window.location.hostname;

  if (hostname.search('localhost') > -1) {
    return SplitIOAPIKey.Dev;
  } else if (hostname.startsWith('appdev1') || hostname.startsWith('appdev2')) {
    return SplitIOAPIKey.Dev;
  } else if (hostname.startsWith('appqa1') || hostname.startsWith('appqa2')) {
    return SplitIOAPIKey.QA;
  } else if (hostname.startsWith('appuat1') || hostname.startsWith('appuat2')) {
    return SplitIOAPIKey.UAT;
  } else if (hostname.startsWith('app.')) {
    return SplitIOAPIKey.Prod;
  } else {
    return SplitIOAPIKey.Dev;
  }
};
